<h3 [style]="titleAndTextStyles()">{{ title() }}</h3>
<i class="fas fa-times dismiss-icon" *ngIf="dismissable()" (click)="onDismiss.emit()"></i>
<div class="text-and-link-container">
  <span [style]="titleAndTextStyles()" class="v-align-middle notification-text" [innerHTML]="text() ? text() : ''"></span>
  <p-button *ngIf="hasButton()" class="v-align-middle" [link]="true" styleClass="text-sm {{ newLineButtonClass() }}" [label]="buttonText()" (click)="buttonClick.emit()" />
</div>
